import request from "_private/utils/request";
/**
 * 初始化区位树
 */
export function FetchVehicleTree() {
  return request({
    url: "/base/storageAreaInfo/getStorageAreaInfoTree",
    method: "post",
  });
}
// 车辆运行分析日报列表数据
export function FetchVehicleAnalysisByDaily(data) {
  return request({
    url: "/report/VehicleRunAnalysis/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}
// 通行证车辆记录
export function FetchVehiclePassCheck(data) {
  return request({
    url: "/reserve/vehicle/list",
    method: "post",
    // headers: { type: "json" },
    data,
  });
}
// 更新冷配车辆信息
export function saveUpdateColdVehicleInfo() {
  return request({
    url: "/reserve/vehicle/patch",
    method: "post",
  });
}
// 车辆离线报表
export function FetchVehicleOutline(data) {
  return request({
    url: "/base/vehicle/out/vehicle",
    method: "post",
    // headers: { type: "json" },
    data,
  });
}

// 导出车辆运行分析日报数据
export function exportVehicleAnalysisByDaily(data) {
  return request({
    url: "/report/VehicleRunAnalysis/exportList",
    method: "post",
    data,
  });
}
// 车辆使用率汇总列表数据
export function FetchVehicleUseRate(data) {
  return request({
    url: "/report/VehicleUsageRate/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}

// 导出车辆使用率汇总数据
export function exportVehicleUseRate(data) {
  return request({
    url: "/report/VehicleUsageRate/exportList",
    method: "post",
    data,
  });
}
// 车辆进出区域汇总列表数据
export function FetchVehicleInOutByPage(data) {
  return request({
    url: "/report/ReportPassAreaPool/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}

// 导出车辆进出区域汇总数据
export function exportVehicleInOut(data) {
  return request({
    url: "/report/store/info/findByPage",
    method: "post",
    data,
  });
}
// 车辆进出区域明细列表数据
export function FetchVehicleInOutDetailByPage(data) {
  return request({
    url: "/report/ReportPassAreaPointP/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}

// 导出车辆进出区域明细数据
export function exportVehicleInOutDetail(data) {
  return request({
    url: "/report/store/info/findByPage",
    method: "post",
    data,
  });
}
// 车辆停车汇总列表数据
export function FetchVehicleStopByPage(data) {
  return request({
    url: "/report/stopVehicleSummary/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}
// 车辆停车明细列表数据
export function FetchVehicleStopDetailByPage(data) {
  return request({
    url: "/report/stopVehicleDetail/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}
// 装卸货载重分析表
export function FetchWeightAnalysis(data) {
  return request({
    url: "/report/loadAndUnloadAnalysis/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}
// 导出
export function exportWeightAnalysis(data) {
  return request({
    url: "/report/loadAndUnloadAnalysis/export",
    method: "post",
    responseType: "blob",
    headers: { type: "json" },
    data,
  });
}

// 冷库温度数据分析表
export function FetchColdStorageData(data) {
  return request({
    url: "/report/ReportTempAnalysis/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}


// 车辆限行区域行驶统计
export function fetchReportPassAreaRestriction(data) {
  return request({
    url: "/report/ReportPassAreaRestriction/findByPage",
    method: "post",
    headers: { type: "json" },
    data,
  });
}

// 导出车辆限行区域行驶统计
export function exportReportPassAreaRestriction(data) {
  return request({
    url: "/report/ReportPassAreaRestriction/exportList",
    method: "post",
    responseType: "blob",
    headers: { type: "json" },
    data,
  });
}
